/******/ (() => { // webpackBootstrap
/*!************************************!*\
  !*** ./resources/js/collection.js ***!
  \************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var collection = /*#__PURE__*/function () {
  function collection(currentTarget) {
    _classCallCheck(this, collection);

    currentTarget.addEventListener('click', this);
    currentTarget.addEventListener('change', this);
    currentTarget.addEventListener('keyup', this);
    currentTarget.addEventListener('collection', this);
    this.height = '';
  }

  _createClass(collection, [{
    key: "handleEvent",
    value: function handleEvent(event) {
      this['on' + event.type](event);
    }
  }, {
    key: "onclick",
    value: function onclick(event) {
      if (event.target.classList.contains('js-filter')) {
        this.buildQuery();
      }
    }
  }, {
    key: "oncollection",
    value: function oncollection(event) {
      this.buildQuery();
    }
  }, {
    key: "onkeyup",
    value: function onkeyup(event) {
      event.preventDefault();

      if (event.code == 'enter') {
        this.buildQuery();
      }
    }
  }, {
    key: "onchange",
    value: function onchange(event) {
      if (event.target.id == 'sort_by') {
        this.buildQuery();
      }
    }
  }, {
    key: "buildQuery",
    value: function buildQuery() {
      this.height = document.querySelector('#sidebar').style.top;
      var url = window.location.href,
          splitted_collection_url = url.split(theme.collections_url + '/');
      collection_url_naked = splitted_collection_url[0] + theme.collections_url, collection_path_and_params = splitted_collection_url[1].split('?'), collection_handle = collection_path_and_params[0].split('/')[0], url_params = new URLSearchParams(window.location.search);
      var tags = [];
      document.querySelectorAll('.js-tag-filter:checked').forEach(function (element) {
        tags.push(element.value);
      });
      var shopify_filter = {};
      document.querySelectorAll('.js-shopfiy-filter').forEach(function (element) {
        if (!(element.name in shopify_filter)) {
          shopify_filter[element.name] = [];
        }

        if (element.type == 'checkbox' && element.checked || (element.type == 'number' || element.type == 'text') && element.value.length) {
          shopify_filter[element.name].push(element.value);
        }
      });
      var shopify_keys = Object.keys(shopify_filter);

      if (shopify_keys.length) {
        shopify_keys.forEach(function (key) {
          if (shopify_filter[key].length) {
            url_params.set(key, shopify_filter[key].join(','));
          } else {
            url_params["delete"](key);
          }
        });
      }

      url_params.set('section_id', document.querySelector('.collection-template-section').id.replace('shopify-section-', ''));

      if (document.getElementById('sort_by')) {
        url_params.set('sort_by', document.getElementById('sort_by').value);
      }

      this.reload(collection_url_naked + '/' + collection_handle + '/' + tags.join(',') + '?' + url_params.toString());
    }
  }, {
    key: "reload",
    value: function reload(url) {
      var _this = this;

      document.querySelector('#loading').style.display = "block";
      fetch(url, {
        method: "GET"
      }).then(function (response) {
        return response.text();
      }).then(function (body) {
        document.querySelector('.collection-template-section').innerHTML = body;
        document.querySelector('#loading').style.display = "hidden";
        document.querySelector('#sidebar').style.top = _this.height;
      });
      this.updateHistory(url);
    }
  }, {
    key: "updateHistory",
    value: function updateHistory(url) {
      var new_url = new URL(url);
      new_url.searchParams["delete"]('section_id');
      window.history.replaceState({}, '', new_url);
    }
  }]);

  return collection;
}();

new collection(document.body);
/******/ })()
;